const colorVolumes: number[] = [
  25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900,
]
export default colorVolumes
